
export function getLongestTransitionMS(element?: HTMLElement): number {
  const cssTimeUnitRegex = (/(\d*\.?\d+)\s?(s|ms+)/igm);
  const getHighestValueMS = (str: string) => Array.from(str.matchAll(cssTimeUnitRegex))
    .map(([_, value, unit]) => ([value, unit])) // extract value and unit from expected positions
    .map(([value, unit]) => unit === 's' ? parseFloat(value)*1000 : parseFloat(value)) // convert to ms as a number
    .sort((a, b) => b - a) // sort descending
    [0] ?? 0.0; // get highest value or 0.0 if none
  if (element) {
    const { transitionDelay, transitionDuration } = window.getComputedStyle(element);
    const transitionDelayMS = getHighestValueMS(transitionDelay);
    const transitionDurationMS = getHighestValueMS(transitionDuration);
    return transitionDelayMS + transitionDurationMS;
  }
  return 0;
}